import { UPDATE_POSITION } from './types'

export const updatePositionAction = (state: any): any => ({ type: UPDATE_POSITION, payload: state })